/**
 * Created by niko on 1/1/16.
 */

'use strict';

const BaseStore = require('fluxible/addons/BaseStore');

class UserSocialNetworkStore extends BaseStore {

    constructor(dispatcher) {
        super(dispatcher);

        this._collection = null;
        this._isLoaded = false;
    }

    _onLoad({socialNetworks}) {
        this._collection = socialNetworks;
        this._isLoaded = true;
        this.emitChange();
    }

    getCollection() {
        return this._collection;
    }

    isLoaded() {
        return this._isLoaded;
    }

    getSocialNetworks(name) {
        if (this._collection) {
            const socialNetworks = [];

            this._collection.toJSON().forEach(network => {
                if (network.socialNetwork.name === name) {
                    socialNetworks.push(network);
                }
            });

            return socialNetworks;
        }

        return [];
    }

    getConnectedSocialNetwork(name) {
        const model = this._collection && this._collection.getConnected(name);
        return model && model.toJSON();
    }

}

UserSocialNetworkStore.storeName = 'UserSocialNetworkStore';

UserSocialNetworkStore.handlers = {
    'user:socialNetworks:load': '_onLoad',
    'user:socialNetwork:connect': 'emitChange',
    'user:socialNetwork:update': 'emitChange',
    'user:socialNetwork:disconnect': 'emitChange'
};

module.exports = UserSocialNetworkStore;



// WEBPACK FOOTER //
// ./assets/js/user/stores/UserSocialNetworkStore.es.js